/**
 * Single sport model
 */
export default class SportModel {
  /**
   * class constructor method
   * @param data
   */
  constructor({ id = 0, n = '', c = '', t = 3 }) {
    /**
     * Sport ID
     * @type {number}
     */
    this.id = id;
    /**
     * Sport Name
     * @type {string}
     */
    this.name = n;
    /**
     * CSS Class
     * @type {string}
     */
    this.class = c;
    /**
     * Sport type
     * 1 -> outright
     * 2 -> two way
     * 3 -> 3 way
     * @type {number}
     */
    this.type = t;
  }
}
